import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { countryInterpretor } from '../../../utils/interpretor';
import { capitalize } from '../../../utils/baseurl.encoder';

@HimuraInject.NamedService('PresaleDetailDelegate')
export class PresaleDetailDelegate extends DataDelegate {

    constructor() {
        super('PresaleDetailDelegate');
    }

    public async getDetail(identifier: string) {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        // const apiHost = 'http://192.168.0.94:9528';
        let requestParams: any = {};
        requestParams = {
            'identifier': `${identifier}`,
            'ltype': `0`,
        };
        const fetched = await AxiosPromise.get(`${apiHost}/rifoListings/queryByIdentifier?` +  Object.keys(requestParams).map(function(k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(requestParams[k]);
        }).join('&'));
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            if (T_T.simpleDetect(fetched.data)) {
                this.Data = this._listingMapper(fetched.data);
            }
            return 1;
        } else {
            return 0;
        }
    }

    public async getStageDetail(identifier: string) {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        let requestParams: any = {};
        requestParams = {
            'identifier': `${identifier}`,
            'ltype': `0`,
        };
        const fetched = await AxiosPromise.get(`${apiHost}/rifoListings/queryByIdentifier?` + Object.keys(requestParams).map(function(k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(requestParams[k]);
        }).join('&'));
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            if (T_T.simpleDetect(fetched.data)) {
                return this._listingStageMapper(fetched.data);
            }
        } else {
            return 0;
        }
    }

    private _listingMapper(v: any) {
        const province = T_T.simpleDetect(v.province) ? v.province : '';
        const city = T_T.simpleDetect(v.city) ? v.city : '';
        const streetNumber = T_T.simpleDetect(v.address.streetNumber) ? v.address.streetNumber : '';
        const streetName = T_T.simpleDetect(v.address.streetName) ? v.address.streetName : '';
        const postalCode = T_T.simpleDetect(v.address.postalCode) ? v.address.postalCode : '';
        const fullAddress = `${streetNumber} ${capitalize(streetName)} ${postalCode}, ${city}, ${province}`;
        return {
            identifier: v.identifier,
            pictureOne: v.pictures.length > 0 ? v.pictures[0] : '',
            pictureTwo: v.pictures.length > 1 ? v.pictures[1] : '',
            title: T_T.simpleDetect(v.preConstructionName) ? v.preConstructionName : '',
            fullAddress: fullAddress,
            price: T_T.simpleDetect(v.price) ? v.price : '',
            bedrooms: T_T.simpleDetect(v.bedrooms) ? v.bedrooms : '',
            bedroomsPlus: T_T.simpleDetect(v.bedroomsPlus) ? v.bedroomsPlus : '',
            washrooms: T_T.simpleDetect(v.washrooms) ? v.washrooms : '',
            garages: T_T.simpleDetect(v.garages) ? v.garages : '',
            parkingSpaces: T_T.simpleDetect(v.parkingSpaces) ? v.parkingSpaces : '',
            location: {},
            remark: T_T.simpleDetect(v.remark) ? v.remark : '',
            agentId: T_T.simpleDetect(v.agents) ? v.agents.length > 0 ? v.agents[0].id : null : null,
            province: province,
            city: city,
            streetName: streetName,
            streetNumber: streetNumber,
            postalCode: postalCode,
        };
    }

    private _listingStageMapper(v: any) {
        return {
            identifier: v.identifier,
            pictureOne: v.pictures.length > 0 ? v.pictures[0] : '',
            pictureTwo: v.pictures.length > 1 ? v.pictures[1] : '',
            title: T_T.simpleDetect(v.preConstructionName) ? v.preConstructionName : '',
            fullAddress: T_T.simpleDetect(v.fullAddress) ? v.fullAddress : '',
            price: T_T.simpleDetect(v.price) ? v.price : '',
            bedrooms: T_T.simpleDetect(v.bedrooms) ? v.bedrooms : '',
            bedroomsPlus: T_T.simpleDetect(v.bedroomsPlus) ? v.bedroomsPlus : '',
            washrooms: T_T.simpleDetect(v.washrooms) ? v.washrooms : '',
            garages: T_T.simpleDetect(v.garages) ? v.garages : '',
            parkingSpaces: T_T.simpleDetect(v.parkingSpaces) ? v.parkingSpaces : '',
            remark: T_T.simpleDetect(v.remarks) ? v.remarks.client : '',
            country: T_T.simpleDetect(v.country) ? countryInterpretor(v.country) : 'Canada',
            province: T_T.simpleDetect(v.province) ? v.province : '',
            region: T_T.simpleDetect(v.region) ? v.region : '',
            city: T_T.simpleDetect(v.city) ? v.city : '',
            streetNumber: T_T.simpleDetect(v.address.streetNumber) ? v.address.streetNumber : '',
            streetName: T_T.simpleDetect(v.address.streetName) ? v.address.streetName : '',
            postalCode: T_T.simpleDetect(v.address.postalCode) ? v.address.postalCode : '',
            storey: T_T.simpleDetect(v.storey) ? v.storey : '',
            active: T_T.simpleDetect(v.active) ? v.active : true,
            agentId: T_T.simpleDetect(v.agents) ? v.agents.length > 0 ? v.agents[0].id : null : null,
        };
    }
}
